import React from "react";
import { ProcessStepsProps } from ".";
import { Box } from "../Box";
import { Flex } from "../Flex";
import { Grid } from "../Grid";
import { Line } from "../Line";
import { StepItem } from "../StepItem";
import { Title } from "../Title";

// The minimum number of columns
const MIN_ITEM_COLS = 4;

export const ProcessSteps: React.FC<ProcessStepsProps> = ({ title, steps, ...restProps }) => {
  const itemCols = steps.length > MIN_ITEM_COLS ? steps.length : MIN_ITEM_COLS;
  const itemColSize = `${(1 / itemCols) * 100.0}%`;
  return (
    <Box data-testid="ProcessSteps">
      {title && (
        <Title as="h2" pb={4}>
          {title}
        </Title>
      )}
      <Box position="relative">
        <Flex width="100%" position="absolute" top={27} left={2} zIndex={0}>
          <Line opacity={1} display={["none", "none", "block"]} width={(steps.length - 1) / itemCols} bg="secondary" m={0} />
        </Flex>
      </Box>
      <Grid data-testid="ProcessStepsGrid" grid={["100%", "100%", itemColSize, itemColSize, itemColSize]}>
        {steps.map((step, index) => (
          <StepItem
            iconText={`${index + 1}`}
            key={step.text}
            color="secondary"
            circularSize={[50]}
            align="left"
            mb={[4, 4, 0]}
            width="100%"
            {...step}
            {...restProps}
          />
        ))}
      </Grid>
    </Box>
  );
};

ProcessSteps.defaultProps = {
  fontSize: 1,
  titleFontSize: 3,
  iconMb: 2,
};
